import flatpickr from "flatpickr";
import "../stylesheets/tw/components/flatpickr.css";
import { Czech } from "flatpickr/dist/l10n/cs.js";
import { German } from "flatpickr/dist/l10n/de.js";
import { English } from "flatpickr/dist/l10n/default.js";
import { Spanish } from "flatpickr/dist/l10n/es.js";
import { French } from "flatpickr/dist/l10n/fr.js";
import { Hungarian } from "flatpickr/dist/l10n/hu.js";
import { Italian } from "flatpickr/dist/l10n/it.js";
import { Slovak } from "flatpickr/dist/l10n/sk.js";

const locales = {
  cs: Czech,
  de: German,
  en: English,
  es: Spanish,
  fr: French,
  hu: Hungarian,
  it: Italian,
  sk: Slovak,
};

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('input[data-provide="datepicker"]').forEach(function(input) {
    let dateFormat = input.dataset.dateFormat || 'd. m. Y';
    dateFormat = dateFormat.replace('yyyy', 'Y').replace('dd', 'd').replace('mm', 'm');
    const lang = input.dataset.dateLanguage || 'cs';
    flatpickr(input, {
      dateFormat: dateFormat || 'd. m. Y',
      locale: locales[lang] || Czech,
    });
  });
});